import React, {Component} from 'react';
import WrapComponent from '../../component/WrapComponent';
import SelectElement from './select';

class SelectIndex extends Component{
    getCascadeOptions = ()=>{
        let options = this.getChildOptions();

        if (!options){
            return [];
        }
        let opts = this.props.options;
        // return options.map(value =>{
        //     let option = opts.filter(item=>{
        //         return item.value === value;
        //     });
        //     return option && option[0];
        // });
        let optionArr = [];
        options.forEach(value =>{
            let option = opts.filter(item=>{
                return item.value === value;
            });
            if(option && option.length) {
                optionArr.push(option[0])
            }
        });
        return optionArr;
    }
    getChildOptions = ()=>{
        let parent = this.props.parent_node;
        let options = parent && parent.options;
        if (!options){
            return;
        }
        
        let {form, api_name, type} = this.props;
        let is_area_type = ['country', 'province', 'city', 'district'].indexOf(type) > -1;

        //父级选择的值
        let value = form.getFieldValue(parent.api_name);
        
        // 选择的选项
        let option = options.filter((item)=>{
            return item.value === value;
        });
        // 子选项
        let child_options = (option && option[0] && option[0].child_options) || [];
        
        let child = child_options.find((item)=>{
            if (is_area_type) {
                return item[type]
            }else {
                return item[api_name];
            }
        });

        if (is_area_type) {
            return child && child[type];
        }else {
            if(child && child[api_name] && child[api_name].length>0){
                child[api_name].forEach((item,i) => {
                    if(item == 'other'){
                        child[api_name].push(...child[api_name].splice(i,1))
                    }
                })
            }
            return child && child[api_name];
        }
    }
    componentWillMount(){
        this.isFirstShow = true
    }

    render(){
        let {api_name, form, is_required, default_value, parent_node, type} = this.props;
        
        const {getFieldProps} = form;
        
        if(parent_node) {
            //父级的值
            let parentValue = form.getFieldValue(parent_node.api_name)||'';
            //父级默认的值
            let parentDefaultValue = parent_node.default_value||'';
            //第一次进来展示默认值，父级选项变动时，子级不再展示设置的默认值
            if(this.isFirstShow && parentValue != parentDefaultValue) {
                this.isFirstShow = false
            }
        }  

        let fieldProps = getFieldProps(api_name, {
            initialValue: this.isFirstShow?default_value:'',
            validate: [{
                trigger: 'onChange',
                rules:[{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }],
            normalize: function(v, prev){
                let res;
                if (type === 'true_or_false') {
                    res = (v === false || v === 'false') ? false : true;
                }else {
                    res = v;
                }
                return res; 
            }
        });
        let Element = SelectElement; 
        
        let temp = {};
        let options = parent_node && this.getCascadeOptions();
        
        if (options){
            temp.options = options;
        }
        
        return (
            <Element {...this.props} {...fieldProps} {...temp}/>
        )
    }
}

export default WrapComponent(SelectIndex);


// WEBPACK FOOTER //
// ./src/form/select/index.js